import { createContext, useContext, useState, useCallback, useEffect } from "react";

const dict = {
  es: {
    nav: {
      inicio: "Inicio", nosotros: "Nosotros", servicios: "Servicios",
      metodologia: "Cómo trabajamos", normas: "Normas y certificaciones",
      casos: "Casos de éxito", clientes: "Clientes", contacto: "Contacto",
      cta: "Solicitar asesoría",
    },
    common: {
      solicitarAsesoria: "Solicitar una asesoría",
      conocerServicios: "Conocer nuestros servicios",
      masInfo: "Más información",
      verCaso: "Ver caso completo",
      todosCasos: "Conocer todos los casos de éxito",
      contactarWhatsapp: "Contactar por WhatsApp",
      verRecursos: "Ver todos los recursos",
    },
  },
  en: {
    nav: {
      inicio: "Home", nosotros: "About", servicios: "Services",
      metodologia: "How we work", normas: "Standards & certifications",
      casos: "Case studies", clientes: "Clients", contacto: "Contact",
      cta: "Request advisory",
    },
    common: {
      solicitarAsesoria: "Request an advisory",
      conocerServicios: "Explore our services",
      masInfo: "Learn more",
      verCaso: "Read full case",
      todosCasos: "See all case studies",
      contactarWhatsapp: "Contact via WhatsApp",
      verRecursos: "Browse all resources",
    },
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("kb_lang") || "es");
  useEffect(() => {
    localStorage.setItem("kb_lang", lang);
    document.documentElement.lang = lang === "es" ? "es-CR" : "en";
  }, [lang]);
  const t = useCallback((path) => {
    const parts = path.split(".");
    let ref = dict[lang];
    for (const p of parts) ref = ref?.[p];
    return ref || path;
  }, [lang]);
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be inside I18nProvider");
  return ctx;
}
